module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="experience-thumb-wrapper">\n\n    ';
 if (showExperienceActionsPanel) { ;
__p += '\n        <div class="actions-panel">\n            ';
 if (canDelete) { ;
__p += '\n                <span class="delete pull-right" data-content="Delete ' +
__e( itemLabel ) +
' forever"></span>\n                <span class="spinner loading-spinner pull-right hidden" data-spinner-color="#000" data-spinner-size="20">\n                    <span class="ladda-label"></span>\n                </span>\n            ';
 } else if (spectatorMode) { ;
__p += '\n                <span class="delete pull-right disabled" data-content="You do not have permission to delete ' +
__e( itemLabel ) +
's"></span>\n            ';
 } else { ;
__p += '\n                <span class="delete pull-right disabled" data-content="You do not have permission to delete pushed ' +
__e( itemLabel ) +
's"></span>\n            ';
 } ;
__p += '\n            ';
 if (spectatorMode) { ;
__p += '\n                <span class="detach pull-right disabled" data-content="You do not have permission to detach ' +
__e( itemLabel ) +
's"></span>\n                <span class="duplicate pull-right disabled" data-content="You do not have permission to duplicate ' +
__e( itemLabel ) +
's"></span>\n            ';
 } else { ;
__p += '\n                <span class="detach pull-right" data-content="Detach ' +
__e( itemLabel ) +
'"></span>\n                <span class="duplicate pull-right" data-content="Duplicate ' +
__e( itemLabel ) +
'"></span>\n            ';
 } ;
__p += '\n        </div>\n    ';
 } ;
__p += '\n\n    ';
 if (group) { ;
__p += '\n        <div class="group-thumb-container">\n            <div class="variant-thumbs-wrapper">\n                ';
 _.each(thumbs, function (thumb) { ;
__p += '\n                    <div class="variant-outline" style="width:' +
__e( thumb.width ) +
'px; height:' +
__e( thumb.height ) +
'px; left:' +
__e( thumb.x ) +
'px;"></div>\n                ';
 }); ;
__p += '\n                <div class="experience-thumb-container"></div>\n            </div>\n        </div>\n    ';
 } else { ;
__p += '\n        <div class="experience-thumb-container"></div>\n    ';
 } ;
__p += '\n\n    <div class="experience-meta-data">\n        <div class="title-wrapper">\n            <span class="title-container" data-content="' +
__e( name ) +
'">\n                <span class="title">' +
__e( name ) +
'</span>\n            </span>\n            ';
 if (group) { ;
__p += '\n                <span class="group-count">(' +
__e( entries.length ) +
')</span>\n            ';
 } ;
__p += '\n            ';
 if (hasComments) { ;
__p += '\n                <span class="comments-indicator"></span>\n            ';
 } ;
__p += '\n        </div>\n\n        ';
 if (group) { ;
__p += '\n            <ul class="group-variants ' +
__e(groupType ) +
'">\n                ';
 _.each(entries, function (entry, index) {
                    var identifier = entry[1] ? entry[1].getIdentifier() : "";
                ;
__p += '\n                    ';
 if (index < 8) { ;
__p += '\n                        <li class="variant-icon ' +
__e(identifier ) +
' small">#' +
__e( index + 1 ) +
'</li>\n                    ';
 } else if (index === 8) { ;
__p += '\n                        <li class="ellipsis">&#133;</li>\n                    ';
 } ;
__p += '\n                ';
 }); ;
__p += '\n            </ul>\n        ';
 } else { ;
__p += '\n            <div class="state">Status: ' +
__e( readableState ) +
'</div>\n        ';
 } ;
__p += '\n    </div>\n</div>\n\n';
 if (showSelectIndicator) { ;
__p += '\n    <div class="select-indicator in-project"></div>\n    <div class="select-indicator selected"></div>\n    <div class="select-indicator in-other-project" data-content="This ' +
__e(itemLabel) +
' belongs to another Project and will be detached from there if attached to this Project."></div>\n    <div class="select-indicator in-other-project-selected" data-content="This ' +
__e(itemLabel) +
' will be detached from another Project and attached to this Project."></div>\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/projects/content/ProjectContentItemView.tpl
// module id = 3082
// module chunks = 0